(function(){
var RM=window.matchMedia('(prefers-reduced-motion: reduce)');
var seam,ticking=false;

function progress(){
  var h=document.documentElement;
  var max=(h.scrollHeight-window.innerHeight);
  var p=max>0?Math.min(1,Math.max(0,window.pageYOffset/max)):0;
  h.style.setProperty('--cz-p',p.toFixed(4));
}
function onScroll(){if(ticking)return;ticking=true;requestAnimationFrame(function(){progress();ticking=false})}

function reveal(){
  var els=[].slice.call(document.querySelectorAll('.cz-r:not(.in)'));
  if(!els.length)return;
  if(RM.matches||!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});return}
  var io=new IntersectionObserver(function(en){
    en.forEach(function(e){
      if(!e.isIntersecting)return;
      var el=e.target,g=el.parentNode?[].slice.call(el.parentNode.querySelectorAll(':scope > .cz-r')):[el];
      var i=Math.max(0,g.indexOf(el));
      el.style.transitionDelay=Math.min(i*90,540)+'ms';
      el.classList.add('in');
      el.addEventListener('transitionend',function h(){el.style.transitionDelay='';el.removeEventListener('transitionend',h)});
      io.unobserve(el);
    });
  },{rootMargin:'0px 0px -8% 0px',threshold:.12});
  els.forEach(function(e){io.observe(e)});
}

function pin(){document.body.classList.add('cz-rm');document.querySelectorAll('.cz-r').forEach(function(e){e.classList.add('in');e.style.transitionDelay=''});}
function unpin(){document.body.classList.remove('cz-rm');}

function init(){
  seam=document.querySelector('.cz-seam');
  progress();reveal();
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  if(RM.matches)pin();
  RM.addEventListener('change',function(e){if(e.matches){pin()}else{unpin();reveal()}});
  document.addEventListener('visibilitychange',function(){document.body.classList.toggle('cz-paused',document.hidden)});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',function(){progress();reveal()});
})();
